import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
            light: '#42a5f5',
            dark: '#1565c0',
        },
        secondary: {
            main: '#9c27b0',
            light: '#ba68c8',
            dark: '#7b1fa2',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minHeight: '44px', // iOS recommended touch target size
                    '@media (max-width: 600px)': {
                        minHeight: '48px', // Larger on mobile for better touch
                        fontSize: '16px', // Prevent zoom on iOS
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& input': {
                        '@media (max-width: 600px)': {
                            fontSize: '16px', // Prevent zoom on iOS
                        },
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    '@media (max-width: 600px)': {
                        padding: '8px 4px', // Tighter padding on mobile
                        fontSize: '14px',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '@media (max-width: 600px)': {
                        minWidth: '44px', // iOS recommended touch target
                        minHeight: '44px',
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '@media (max-width: 600px)': {
                        minHeight: '48px', // Better touch targets on mobile
                    },
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    '@media (max-width: 600px)': {
                        minHeight: '56px', // Standard mobile toolbar height
                        paddingLeft: '16px',
                        paddingRight: '16px',
                    },
                },
            },
        },
    },
    typography: {
        h6: {
            '@media (max-width: 600px)': {
                fontSize: '1.1rem',
            },
        },
    },
});

export default theme;
